(function (win, $) {
    'use strict';
    var fp = (win.fp = typeof win.fp !== 'undefined' ? win.fp : {}),
        home = (fp.home = typeof fp.home !== 'undefined' ? fp.home : {});

    fp.home = (function () {
        var windowHeight;
        var initialized = false;

        var getScreenSize = function () {
            var pixelDensity = window.devicePixelRatio || 1;
            var width = window.innerWidth * pixelDensity;

            if (width >= 2400) {
                return 'xlarge';
            }
            if (width >= 1400) {
                return 'large';
            }
            if (width >= 1000) {
                return 'medium';
            }
            if (width >= 600) {
                return 'small';
            }
            return 'xsmall';
        };

        return {
            init: function () {
                if (initialized) {
                    return;
                }
                initialized = true;

                // =========================================
                // Set selected nav
                // =========================================
                $('.homepage-link').addClass('selected');

                // =========================================
                // Detect scroll
                // =========================================

                $(window).scroll(function () {
                    var height = $(window).scrollTop();

                    if (height > 50) {
                        $('body').addClass("scrolled-down");
                    } else {
                        $('body').removeClass("scrolled-down");
                    }
                });

                // =========================================
                // Detect sizes
                // =========================================

                function sizeDetector() {
                    // Define header and mobile utility height and set css variable

                    const root = document.documentElement;

                    var headerHeight = $('header').outerHeight();
                    if (headerHeight === undefined || headerHeight === null) {
                        headerHeight = 0;
                    }
                    root.style.setProperty("--header-height", headerHeight + "px");

                    var logoMobileHeight = $('#logo-mobile').outerHeight();
                    if (logoMobileHeight === undefined || logoMobileHeight === null) {
                        logoMobileHeight = 0;
                    }
                    root.style.setProperty("--logo-mobile-height", logoMobileHeight + "px");

                    var utilityHeight = $('#utility').outerHeight();
                    if (utilityHeight === undefined || utilityHeight === null) {
                        utilityHeight = 0;
                    }
                    root.style.setProperty("--utility-height", utilityHeight + "px");

                    var specialMessageHeight = $('#special-message.message-banner').outerHeight();
                    if (specialMessageHeight === undefined || specialMessageHeight === null || $('#special-message.message-banner').css('display') === 'none') {
                        specialMessageHeight = 0;
                    }
                    root.style.setProperty("--special-message-height", specialMessageHeight + "px");

                    var stickyFooterHeight = $('#ao-sticky').outerHeight();
                    if (stickyFooterHeight === undefined || stickyFooterHeight === null || $('#ao-sticky').css('display') === 'none') {
                        stickyFooterHeight = 0;
                    }
                    root.style.setProperty("--sticky-footer-height", stickyFooterHeight + "px");

                }

                // =========================================
                // Adjust size of hero
                // =========================================

                function setHeroSize() {

                    // This, along with some CSS, helps smooth out scrolling on small screens
                    if (!$('body').hasClass('hero-set')) {
                        setTimeout(function () {
                            $('body').addClass('hero-set');
                        }, 1000);
                    }
                }

                // =========================================
                // Window Resize Handler
                // =========================================

                // Function to be called after window resize
                function handleResize() {
                    setHeroSize();
                    sizeDetector();
                    //console.log("Window has finished resizing!");
                }

                // Debounce function
                function debounce(func, delay) {
                    let timeoutId;
                    return function () {
                        const context = this;
                        const args = arguments;
                        clearTimeout(timeoutId);
                        timeoutId = setTimeout(() => {
                            func.apply(context, args);
                        }, delay);
                    };
                }

                // Debounced version of handleResize
                const debouncedResizeHandler = debounce(handleResize, 250); // Adjust delay as needed

                // Event listener for window resize
                window.addEventListener('resize', debouncedResizeHandler);

                // Triggered on initial load
                window.addEventListener('load', function () {
                    setTimeout(handleResize, 250); // Same delay as for window resizing
                });

            },

            setBgImage: function (imgInfo) {
                var screenSize = getScreenSize();
                var filteredImages = imgInfo.filter(function (img) {
                    return img.assetSize === screenSize;
                });
                if (filteredImages.length === 0) {
                    return;
                }

                var randomNumber = Math.floor(Math.random() * filteredImages.length);
                var randomBackgroundImage = filteredImages[randomNumber];

                var slideshowEl = document.getElementsByClassName('slideshow')[0];
                slideshowEl.style.backgroundImage = "url('" + randomBackgroundImage.imagePath + "')";
                if (randomBackgroundImage.altText) {
                    slideshowEl.setAttribute("aria-label", randomBackgroundImage.altText);
                    slideshowEl.setAttribute('role', 'img');
                }
            }
        };
    })();
})(window, $);